<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">FAQs</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">FAQs</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="about-institute ptb--100">
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="row row-cols-2 justify-content-center align-items-top mt-3">
          <div class="accordion accordian-class" id="accordionExample1">
            <div class="accordion-item">
              <h2 class="accordion-header accordion-button" id="headingOne" data-bs-toggle="collapse"
                data-bs-target="#timing" aria-expanded="true" aria-controls="collapseOne">
                1. What is the timing of college?
              </h2>
              <div id="timing" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                data-bs-parent="#accordionExample1">
                <div class="accordion-body">
                  <p>GHRCACS: 9 am to 4 pm.</p>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header accordion-button" id="headingOne" data-bs-toggle="collapse"
                data-bs-target="#attendance" aria-expanded="true" aria-controls="collapseOne">
                2. How much attendance is compulsory?
              </h2>
              <div id="attendance" class="accordion-collapse collapse" aria-labelledby="headingOne"
                data-bs-parent="#accordionExample1">
                <div class="accordion-body">
                  <p>75% attendance is compulsory.</p>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header accordion-button" id="headingOne" data-bs-toggle="collapse"
                data-bs-target="#qualified" aria-expanded="true" aria-controls="collapseOne">
                3. Do you have qualified and experienced faculty?
              </h2>
              <div id="qualified" class="accordion-collapse collapse" aria-labelledby="headingOne"
                data-bs-parent="#accordionExample1">
                <div class="accordion-body">
                  <p>Yes, GHRCACS have University Approved and experienced staff.</p>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header accordion-button" id="headingOne" data-bs-toggle="collapse"
                data-bs-target="#uniform" aria-expanded="true" aria-controls="collapseOne">
                4. Is Uniform Compulsory?
              </h2>
              <div id="uniform" class="accordion-collapse collapse" aria-labelledby="headingOne"
                data-bs-parent="#accordionExample1">
                <div class="accordion-body">
                  <p>Yes, We do have uniform for GHRCACS students.</p>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header accordion-button" id="headingOne" data-bs-toggle="collapse"
                data-bs-target="#distance" aria-expanded="true" aria-controls="collapseOne">
                5. What is distance from College to Railway Station or<br> Bus Stand?
              </h2>
              <div id="distance" class="accordion-collapse collapse" aria-labelledby="headingOne"
                data-bs-parent="#accordionExample1">
                <div class="accordion-body">
                  <p>15.2 Km away from main station.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="accordion accordian-class" id="accordionExample2">
            <div class="accordion-item">
              <h2 class="accordion-header accordion-button" id="headingOne" data-bs-toggle="collapse"
                data-bs-target="#facilities" aria-expanded="true" aria-controls="collapseOne">
                6. Part Payments facility is Available or not?
              </h2>
              <div id="facilities" class="accordion-collapse collapse" aria-labelledby="headingOne"
                data-bs-parent="#accordionExample2">
                <div class="accordion-body">
                  <p>Available subject to condition.</p>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header accordion-button" id="headingOne" data-bs-toggle="collapse"
                data-bs-target="#management" aria-expanded="true" aria-controls="collapseOne">
                7. Can I pay fees in installments?
              </h2>
              <div id="management" class="accordion-collapse collapse" aria-labelledby="headingOne"
                data-bs-parent="#accordionExample2">
                <div class="accordion-body">
                  <p>Yes, As per management Policy.</p>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header accordion-button" id="headingOne" data-bs-toggle="collapse"
                data-bs-target="#management" aria-expanded="true" aria-controls="collapseOne">
                8. What is Admission Cancellation Policy?
              </h2>
              <div id="management" class="accordion-collapse collapse" aria-labelledby="headingOne"
                data-bs-parent="#accordionExample2">
                <div class="accordion-body">
                  <p>Cancellation Policy as per RGI Rules and Regulation.</p>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header accordion-button" id="headingOne" data-bs-toggle="collapse"
                data-bs-target="#documents" aria-expanded="true" aria-controls="collapseOne">
                9. What are the documents required for admission?
              </h2>
              <div id="documents" class="accordion-collapse collapse" aria-labelledby="headingOne"
                data-bs-parent="#accordionExample2">
                <div class="accordion-body">
                  <p>
                    <strong>For BBA/BCA/B.Com/B.Sc(Comp.Sci.):</strong>
                  </p>
                  <ul class="list-before">
                    <li>1) SSC Mark sheet</li>
                    <li>2) HSC Mark sheet</li>
                    <li>3) Leaving Certificate / TC</li>
                    <li>4) Gap Certificate (If applicable)</li>
                    <li>5) Migration certificate(Other state)</li>
                    <li>6) 2- passport size photo</li>
                  </ul>

                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header accordion-button" id="headingOne" data-bs-toggle="collapse"
                data-bs-target="#provision" aria-expanded="true" aria-controls="collapseOne">
                10. Is there any provision for Sports Quota Admission?
              </h2>
              <div id="provision" class="accordion-collapse collapse" aria-labelledby="headingOne"
                data-bs-parent="#accordionExample2">
                <div class="accordion-body">
                  <p>Yes, As per management Policy.</p>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header accordion-button" id="headingOne" data-bs-toggle="collapse"
                data-bs-target="#college" aria-expanded="true" aria-controls="collapseOne">
                11. Does the college provides bus facility?
              </h2>
              <div id="college" class="accordion-collapse collapse" aria-labelledby="headingOne"
                data-bs-parent="#accordionExample2">
                <div class="accordion-body">
                  <p>No.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
